var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.page ? _c('div', [_vm.page ? _c('Banner', {
    attrs: {
      "page": _vm.page
    }
  }) : _vm._e(), _vm._m(0), _vm.getArticles ? _c('Articles', {
    attrs: {
      "articles": _vm.getArticles
    }
  }) : _vm._e(), _c('section', {
    staticClass: "container-fluid contact-us"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "content text-center"
  }, [_c('h2', [_vm._v(_vm._s(_vm.page.contact_section_heading))]), _c('router-link', {
    attrs: {
      "to": {
        name: 'contacts'
      }
    }
  }, [_vm._v("CONTACT US")])], 1)])])])]), _c('section', {
    staticClass: "device"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "cycle-icon-trans"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": ((_vm.assetsUrl()) + "/images/cycle-icon.png"),
      "alt": ""
    }
  })]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 animatedParent"
  }, [_c('h1', {
    staticClass: "animated fadeInLeft go"
  }, [_vm._v(" " + _vm._s(_vm.page.main_devices_heading) + " ")]), _c('div', {
    staticClass: "screens-warp animatedParent"
  }, [_c('div', {
    staticClass: "apple-screen animated growIn go"
  }, [_c('p', [_vm._v(_vm._s(_vm.page.apple_device_heading))]), _vm._m(1)]), _c('div', {
    staticClass: "line-mid"
  }), _vm.displayFooter ? _c('div', {
    staticClass: "android-screen animated growIn go"
  }, [_c('p', [_vm._v(_vm._s(_vm.page.android_device_heading))]), _vm._m(2)]) : _vm._e()])])])])]), _c('section', {
    staticClass: "any-time"
  }, [_c('div', {
    staticClass: "container contain"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 animatedParent"
  }, [_c('h1', {
    staticClass: "animated fadeInLeft go"
  }, [_vm._v(" " + _vm._s(_vm.page.playstore_section_heading) + " ")]), _c('p', {
    staticClass: "animated fadeInLeft go",
    domProps: {
      "innerHTML": _vm._s(_vm.page.playstore_section_description)
    }
  }), _c('ul', {
    staticClass: "list-inline store-btn animated fadeInLeft go"
  }, [_c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.setting.applestore
    }
  }, [_c('img', {
    staticClass: "img-normal",
    attrs: {
      "src": ((_vm.assetsUrl()) + "/images/appple.png"),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "img-hover",
    attrs: {
      "src": ((_vm.assetsUrl()) + "/images/apple-hover.png"),
      "alt": ""
    }
  })])]), _vm.displayFooter ? _c('li', {
    staticClass: "list-inline-item"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": _vm.setting.playstore
    }
  }, [_c('img', {
    staticClass: "img-normal",
    attrs: {
      "src": ((_vm.assetsUrl()) + "/images/android.png"),
      "alt": ""
    }
  }), _c('img', {
    staticClass: "img-hover",
    attrs: {
      "src": ((_vm.assetsUrl()) + "/images/andriod-hover.png"),
      "alt": ""
    }
  })])]) : _vm._e()])])])])])], 1) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "head-style"
  }, [_c('h1', [_vm._v(" Welcome to MyWhoosh Support "), _c('br'), _vm._v(" How can we help you? ")])])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', [_c('li', [_vm._v("iPad Mini 5")]), _c('li', [_vm._v("iPad Air 3")]), _c('li', [_vm._v("iPad Pro 2 or above")]), _c('li', [_vm._v("iPad 7")]), _c('li', [_vm._v("iPhone X or above")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ul', [_c('li', [_vm._v("Android Version: 9.0 and above")]), _c('li', [_vm._v("RAM: 4 GB")]), _c('li', [_vm._v("Storage: 32 GB")]), _c('li', [_vm._v("Processor: Snapdragon 660, Mali G52, Adreno 512")])]);
}]

export { render, staticRenderFns }